import { ArrayFieldTemplateProps } from "@rjsf/utils";
import useUpdateSectionAction from "../../actions/updateSection/useUpdateSectionAction";
import { XCircle, ArrowCircleUp, ArrowCircleDown } from "@phosphor-icons/react/dist/ssr";
import { t } from "i18next";

function FeaturedProductsArrayTemplate(
  props: ArrayFieldTemplateProps,
  className: string,
  id: string
) {
  const {actionTemplate} = useUpdateSectionAction();
  const { items, canAdd, onAddClick } = props;

  return (
      <div className={className}>
        {id != "root_sections" ? <><h3>{props.title} {actionTemplate}</h3> </>: null}
        {items &&
        items.map((element) => (
            <div key={element.key} className={element.className}>
              <div className="d-flex flex-row align-items-center products mb-2">{element.children}              
              {element.hasMoveDown && (
                  <ArrowCircleDown size={30} className="ms-2 pe-hand" onClick={element.onReorderClick(element.index, element.index + 1)}/>
              )}
              {element.hasMoveUp && (
                  <ArrowCircleUp size={30} className="ms-2 pe-hand" onClick={element.onReorderClick(element.index, element.index - 1)}/>
              )}
              <XCircle size={30} className="ms-2 pe-hand text-danger" onClick={element.onDropIndexClick(element.index)}/>              
              </div>
            </div>
        ))}

        {canAdd && (
            <div className='row'>
              <p className='col-xs-3 col-xs-offset-9 array-item-add text-left'>
                  <button
                      className="btn btn-primary ml-auto mt-3"
                      onClick={onAddClick}
                  >
                      {t('add_product')} +
                  </button>
              </p>
            </div>
        )}
      </div>
  );
}

export default FeaturedProductsArrayTemplate;
